import { ClearIndicator } from "./ClearIndicator";
import { DropdownIndicator } from "./DropdownIndicator";
import { Input } from "./Input";
import { LoadingIndicator } from "./LoadingIndicator";
import { AutoPositionedMenu, Menu } from "./Menu";
import { MenuList } from "./MenuList";
import { MultiValue, MultiValueRemove } from "./MultiValue";
import { Option } from "./Option";
import { SingleValue } from "./SingleValue";

export const SelectComponents = {
  ClearIndicator,
  DropdownIndicator,
  Input,
  LoadingIndicator,
  Menu,
  AutoPositionedMenu,
  MenuList,
  MultiValue,
  MultiValueRemove,
  Option,
  SingleValue,
};

export * from "./types";
export * from "./useSimpleValue";
